import {rpc} from './session';

export async function getDictionaryLists(keys, meta) {
    return await rpc.request('com.rnis.dictionary.action.lists', {
        keys
    }, {meta});
}

export async function getDictionaryList(key, meta) {
    return await rpc.request('com.rnis.dictionary.action.list', {
        dictionary: {key}
    }, {meta});
}


// WEBPACK FOOTER //
// ./src/helpers/api/dictionary.js